import { render, staticRenderFns } from "./SelectMessageTemplate.vue?vue&type=template&id=47d1cf60"
import script from "./SelectMessageTemplate.vue?vue&type=script&lang=js"
export * from "./SelectMessageTemplate.vue?vue&type=script&lang=js"
import style0 from "./SelectMessageTemplate.vue?vue&type=style&index=0&id=47d1cf60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports